import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import "../styles/TorneosAdmin.css";
import Swal from "sweetalert2";

export default function TorneosAdmin() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [torneos, setTorneos] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
  // Obtener torneos vigentes
  api.get("/torneos?estado=Abierto", {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => setTorneos(res.data))
    .catch((err) => {
      console.error("Error al cargar los torneos vigentes:", err);
      setError("Error al cargar los torneos vigentes.");
    });
    // Obtener torneos en progreso
  api.get("/torneos?estado=En%20Progreso", {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => setTorneos((prev) => [...prev, ...res.data]))
    .catch((err) => {
      console.error("Error al cargar los torneos en progreso:", err);
      setError("Error al cargar los torneos en progreso.");
    });

  // Obtener torneos finalizados
  api.get("/torneos?estado=Finalizado", {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => setTorneos((prev) => [...prev, ...res.data]))
    .catch((err) => {
      console.error("Error al cargar los torneos finalizados:", err);
      setError("Error al cargar los torneos finalizados.");
    });
}, [token]);

const actualizarEstadoTorneo = async (torneoId) => {
  const { value: nuevoEstado } = await Swal.fire({
    title: "Actualizar Estado",
    input: "select",
    inputOptions: {
      Abierto: "Abierto",
      "En Progreso": "En Progreso",
      Finalizado: "Finalizado",
    },
    inputPlaceholder: "Selecciona un estado",
    showCancelButton: true,
    confirmButtonText: "Actualizar",
    cancelButtonText: "Cancelar",
  });

  if (!nuevoEstado) return;

  try {
    const response = await api.put(
      `/torneos/${torneoId}/estado`,
      { estado: nuevoEstado },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setTorneos((prevTorneos) =>
      prevTorneos.map((torneo) =>
        torneo.id === torneoId ? { ...torneo, estado: nuevoEstado } : torneo
      )
    );
    Swal.fire({
      title: "Estado Actualizado",
      text: response.data.mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    });
  } catch (err) {
    console.error("Error al actualizar el estado del torneo:", err);
    Swal.fire({
      title: "Error",
      text: "No se pudo actualizar el estado del torneo.",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }
};

  const eliminarTorneo = async (torneoId) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      await api.delete(`/torneos/${torneoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTorneos((prevTorneos) =>
        prevTorneos.filter((torneo) => torneo.id !== torneoId)
      );
      Swal.fire({
        title: "Torneo eliminado",
        text: "El torneo ha sido eliminado exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (err) {
      console.error("Error al eliminar el torneo:", err);
      Swal.fire({
        title: "Error",
        text: "No se pudo eliminar el torneo. Hay parejas inscritas en el torneo.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const finalizarTorneo = async (torneoId) => {
  const result = await Swal.fire({
    title: "¿Estás seguro?",
    text: "¿Deseas finalizar este torneo? Esto registrará los datos en torneos realizados.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, finalizar",
    cancelButtonText: "Cancelar",
  });

  if (!result.isConfirmed) return;

  try {
    const response = await api.put(
      `/torneos/${torneoId}/finalizar`, // Nueva ruta para finalizar torneo
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setTorneos((prevTorneos) =>
      prevTorneos.map((torneo) =>
        torneo.id === torneoId ? { ...torneo, estado: "Finalizado" } : torneo
      )
    );
    Swal.fire({
      title: "Torneo finalizado",
      text: response.data.mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    });
  } catch (err) {
    console.error("Error al finalizar el torneo:", err);
    Swal.fire({
      title: "Error",
      text: "No se pudo finalizar el torneo.",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }
};

  // Filtrar torneos vigentes, en progreso y finalizados
const torneosVigentes = torneos.filter((torneo) => torneo.estado === "Abierto");
const torneosEnProgreso = torneos.filter((torneo) => torneo.estado === "En Progreso");
const torneosFinalizados = torneos.filter((torneo) => torneo.estado === "Finalizado");

return (
  <div className="torneos-admin-container">
    <h2>Torneos</h2>
    {error && <p className="error-message">{error}</p>}

    {/* Torneos Vigentes */}
    <h3>Torneos Vigentes</h3>
    {torneosVigentes.length === 0 ? (
      <p>No hay torneos vigentes disponibles.</p>
    ) : (
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Categoría</th>
            <th>Género</th>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {torneosVigentes.map((torneo) => (
            <tr key={torneo.id}>
              <td>{torneo.nombre}</td>
              <td>{torneo.categoria}</td>
              <td>{torneo.genero}</td>
              <td>{new Date(torneo.fecha_inicio).toLocaleDateString()}</td>
              <td>{new Date(torneo.fecha_fin).toLocaleDateString()}</td>
              <td>{torneo.estado}</td>
              <td>
                <button onClick={() => navigate(`/admin/torneos/${torneo.id}/parejas`)}>
                  Ver Parejas
                </button>
                <button className="eliminar-btn" onClick={() => eliminarTorneo(torneo.id)}>
                  Eliminar Torneo
                </button>
                <button className="finalizar-btn" onClick={() => finalizarTorneo(torneo.id)}>
                  Finalizar
                </button>
                <button className="actualizar-estado-btn" onClick={() => actualizarEstadoTorneo(torneo.id)}>
                  Actualizar Estado
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}

    {/* Torneos en Progreso */}
    <h3>Torneos en Progreso</h3>
    {torneosEnProgreso.length === 0 ? (
      <p>No hay torneos en progreso disponibles.</p>
    ) : (
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Categoría</th>
            <th>Género</th>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {torneosEnProgreso.map((torneo) => (
            <tr key={torneo.id}>
              <td>{torneo.nombre}</td>
              <td>{torneo.categoria}</td>
              <td>{torneo.genero}</td>
              <td>{new Date(torneo.fecha_inicio).toLocaleDateString()}</td>
              <td>{new Date(torneo.fecha_fin).toLocaleDateString()}</td>
              <td>{torneo.estado}</td>
              <td>
                <button onClick={() => navigate(`/admin/torneos/${torneo.id}/parejas`)}>
                  Ver Parejas
                </button>
                <button className="eliminar-btn" onClick={() => eliminarTorneo(torneo.id)}>
                  Eliminar Torneo
                </button>
                <button className="finalizar-btn" onClick={() => finalizarTorneo(torneo.id)}>
                  Finalizar
                </button>
                <button className="actualizar-estado-btn" onClick={() => actualizarEstadoTorneo(torneo.id)}>
                  Actualizar Estado
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}

    {/* Torneos Finalizados */}
    <h3>Torneos Finalizados</h3>
    {torneosFinalizados.length === 0 ? (
      <p>No hay torneos finalizados disponibles.</p>
    ) : (
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Categoría</th>
            <th>Género</th>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          {torneosFinalizados.map((torneo) => (
            <tr key={torneo.id}>
              <td>{torneo.nombre}</td>
              <td>{torneo.categoria}</td>
              <td>{torneo.genero}</td>
              <td>{new Date(torneo.fecha_inicio).toLocaleDateString()}</td>
              <td>{new Date(torneo.fecha_fin).toLocaleDateString()}</td>
              <td>{torneo.estado}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
 
      <button
  onClick={() => {
    // Volver a cargar los torneos
    api.get("/torneos?estado=Abierto", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setTorneos(res.data))
      .catch((err) => {
        console.error("Error al cargar los torneos vigentes:", err);
        setError("Error al cargar los torneos vigentes.");
      });

    api.get("/torneos?estado=Finalizado", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setTorneos((prev) => [...prev, ...res.data]))
      .catch((err) => {
        console.error("Error al cargar los torneos finalizados:", err);
        setError("Error al cargar los torneos finalizados.");
      });
  }}
  style={{ marginTop: "1rem" }}
>
  Actualizar
</button>

      <button onClick={() => navigate(-1)} style={{ marginTop: "1rem" }}>
        Volver atrás
      </button>
    </div>
  );
}